<template>
    <div class="reimbursement-selected-table-view">
        <el-table :data="datas.filter(o => !o.deleted)" style="width: 100%" class="ah-el-data-table" :default-sort="sortSetting" empty-text="沒有資料">
            <el-table-column prop="ioo" label="核銷單號" width="120">
                <template slot-scope="scope">
                    <span class="invoice-label" @click="openInvoiceDetail(scope.row.originSno)">
                        {{ scope.row.ioo }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="狀態" width="90">
                <template slot-scope="scope">
                    <InvoiceStatusLabel :statusNum="scope.row.status" />
                </template>
            </el-table-column>
            <el-table-column prop="description" :min-width="200" label="摘要"> </el-table-column>
            <el-table-column prop="vdR_NAM" label="客戶" :min-width="150" sortable show-overflow-tooltip> </el-table-column>
            <el-table-column prop="amt" label="核銷單總計" align="right" width="110">
                <template slot-scope="scope">
                    <span>
                        <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="tranInvoiceUnInvoiceAmt" label="未開發票金額" align="right" width="110">
                <template slot-scope="scope">
                    <span>
                        <Money :v="scope.row.tranInvoiceUnInvoiceAmt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="thisAmt" label="本次開立金額" align="right" width="150">
                <template slot-scope="scope">
                    <div>
                        <MoneyInput style="text-align: right;" v-model="scope.row.thisAmt" :disabled="disabled" :precision="scope.row.cny == 'TWD' ? 0 : 4" @change="onThisAmtChange" />
                    </div>
                    <div v-if="scope.row.cny !== 'TWD'" align="left" style="color: #555; font-size: 12px; line-height:17px; margin-top: 5px;">
                        <div>匯率：{{ scope.row.rat }}</div>
                        <div>約當台幣：{{ Number(Math.round(scope.row.rat * scope.row.thisAmt)).toLocaleString("en") }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="cny" label="幣別" width="70"> </el-table-column>
            <el-table-column prop="stF_NAM" label="核銷申請人" align="left" width="100"> </el-table-column>
            <el-table-column prop="action" label="操作" width="110" align="right">
                <template v-if="!disabled" slot-scope="scope">
                    <el-button size="mini" @click="removeInvoiceItem(scope.row)">刪除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px">
            <el-button v-if="!disabled" type="primary" @click="onReimbursementSelectDialogOpen">加入核銷單</el-button>
        </div>
        <InvoiceDetailDialog @close="onInvoiceDetailDialogClose" disable-reimbursement-dialog :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
        <ReimbursementSelectDialog
            :visible="reimbursementSelectDialog.visible"
            :selected-invoice="selectedInvoice"
            @openInvoice="openInvoiceDetail($event)"
            @add="onAddInvoice"
            @close="onReimbursementSelectDialogClose"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import ReimbursementSelectDialog from '@/components/dashboard/Finance/ReimbursementInvoice/ReimbursementInvoiceAddLayout/ReimbursementSelectDialog.vue';

export default {
    name: 'ReimbursementSelectedTableView',
    components: { InvoiceStatusLabel, InvoiceDetailDialog, ReimbursementSelectDialog },
    props: {
        isSortByDate: {
            type: Boolean,
            default: true,
        },
        refenceInvoces: {
            type: Array,
            default: () => [],
        },
        disabled: Boolean,
    },
    data() {
        return {
            detailDialogSno: null,
            lastDetailDialogSno: null,

            showPjCustomNumber: false,

            datas: [],

            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            reimbursementSelectDialog: {
                visible: false,
            },
        };
    },
    mounted() {
        const DATA = [];
        this.refenceInvoces.forEach((item) => {
            DATA.push({
                sno: item.sno,
                ioo: item.ioo,
                status: item.originStatus,
                description: item.originDescription,
                vdR_NAM: item.vdR_NAM,
                amt: item.originAMT,
                tranInvoiceUnInvoiceAmt: item.tranInvoiceUnInvoiceAmt,
                thisAmt: item.amt,
                stF_NAM: item.stF_NAM,
                originSno: item.originSno,
                rat: item.originRAT,
                cny: item.originCNY,
                deleted: false,
            });
        });
        this.datas.push(...DATA);
    },
    computed: {
        sortSetting() {
            if (this.isSortByDate) {
                return { prop: 'crT_DAT', order: 'descending' };
            }
            return { prop: null, order: null };
        },
        selectedInvoice() {
            return _.chain(this.datas)
                .filter(['deleted', false])
                .map((o) => o.ioo)
                .value();
        },
    },
    methods: {
        onAddInvoice(items) {
            items.forEach((item) => {
                console.log(item);
                const DATA = item;
                DATA.thisAmt = DATA.tranInvoiceUnInvoiceAmt;
                DATA.sno = null;
                DATA.originSno = DATA.invoiceSNO;
                DATA.deleted = false;
                this.datas.push(DATA);
            });

            this.$emit('change', this.datas);
        },
        onThisAmtChange() {
            this.$emit('change', this.datas);
        },
        removeInvoiceItem(item) {
            const INDEX = this.datas.indexOf(item);
            this.datas[INDEX].deleted = true;
            this.$emit('change', this.datas);
        },

        openInvoiceDetail(sno) {
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        onInvoiceDetailDialogClose() {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        onReimbursementSelectDialogOpen() {
            this.reimbursementSelectDialog.visible = true;
        },
        onReimbursementSelectDialogClose() {
            this.reimbursementSelectDialog.visible = false;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.reimbursement-selected-table-view {
    .invoice-label {
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>
